import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";

import { versionState } from "@accessinformatica/service-worker";
import accidentDashboard from "./accidentDashboard";
import accidents from "./accidents";
import answeredAuthorizations from "./answeredAuthorizations";
import appointments from "./appointments";
import art from "./art";
import arts from "./arts";
import auth from "./auth";
import authorizations from "./authorizations";
import connectivity from "./connectivity";
import connectivityResponse from "./connectivityResponse";
import dashboard from "./dashboard";
import documentType from "./documentType";
import emails from "./emails";
import fields from "./fields";
import files from "./files";
import forms from "./forms";
import formsState from "./formsState";
import importForms from "./importForms";
import notificaciones from "./notificaciones";
import password from "./password";
import pendingAuthorizations from "./pendingAuthorizations";
import providedServices from './providedServices';
import providers from "./providers";
import reports from "./reports";
import userPreferences from "./userPreferences";
import users from "./users";
import messaging from "./messaging";
import traslados from "./traslados";
import audit from "./audit";
import configuration from "./configuration";
import googleMaps from "./googleMaps";

const allReducers = combineReducers({
  authorizations,
  accidents,
  appointments,
  art,
  auth,
  answeredAuthorizations,
  dashboard,
  userPreferences,
  pendingAuthorizations,
  providers,
  users,
  password,
  emails,
  arts,
  accidentDashboard,
  forms,
  reports,
  documentType,
  fields,
  importForms,
  files,
  connectivity,
  connectivityResponse,
  formsState,
  providedServices,
  versionState,
  notificaciones,
  messaging,
  traslados,
  audit,
  configuration,
  googleMaps,
});

const rootReducer = (state, action) => {
  if (action.type === "SIGNOUT_REQUEST") {
    Object.keys(state).forEach((key) => storage.removeItem(`persist:${key}`));
    // Reiniciar los demas reducers
    return allReducers({ auth: state.auth }, action);
  }

  return allReducers(state, action);
};

export default rootReducer;
